/* istanbul ignore next not useful for unit test */
import { html } from 'lit-element'
import type { SingleSpaLitProps } from '../../common/single-spa-lit'
import { singleSpaLit } from '../../common'
import { GOTO_CONTENT_SELECTOR } from './../../common/container'

const lifecycles = singleSpaLit<SingleSpaLitProps>({
  template: html`<goto-shell-landing></goto-shell-landing>`,
  domElement: GOTO_CONTENT_SELECTOR,
})

export default lifecycles
